export class DeactivateGoogleWorkspaceResponse {
    'googleWorkspace';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "googleWorkspace",
            "baseName": "googleWorkspace",
            "type": "GoogleWorkspace",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return DeactivateGoogleWorkspaceResponse.attributeTypeMap;
    }
    constructor() {
    }
}
